import React from 'react';
import { Spinner } from 'react-bootstrap';
import { IconCheck, IconCircleDashed } from '@tabler/icons-react';

const CREATION_STEPS = [
  'Criando perfil do agente...',
  'Configurando capacidades...',
  'Gerando fluxo de conversa...',
  'Configurando base de conhecimento...',
  'Gerando guia de configuração...',
];

const CreationProgress = ({ currentStepIndex, hasKnowledge }) => {
  const steps = hasKnowledge
    ? CREATION_STEPS
    : CREATION_STEPS.filter((_, i) => i !== 3);

  return (
    <div className="awc-progress" aria-live="polite">
      {steps.map((label, i) => {
        let stepModifier = 'pending';
        if (i < currentStepIndex) stepModifier = 'completed';
        else if (i === currentStepIndex) stepModifier = 'active';

        return (
          <div key={i} className={`awc-progress__step awc-progress__step--${stepModifier}`}>
            <div className="awc-progress__icon">
              {stepModifier === 'completed' && <IconCheck size={16} />}
              {stepModifier === 'active' && <Spinner animation="border" size="sm" />}
              {stepModifier === 'pending' && <IconCircleDashed size={16} />}
            </div>
            <span>{label}</span>
          </div>
        );
      })}
    </div>
  );
};

export default CreationProgress;
